<div id="pages">
    <div class="page-title">
        <!-- <div class="actions left">
            <i class="far fa-bars"></i>
        </div> -->
        <h2>Pages</h2>
        <!-- <div class="actions right">
            <i class="far fa-search"></i>
        </div> -->
    </div>
    <div class="alert alert-warning mb-0 mt-0 template-alert">
        <p class="no-margin">By default, only pages you have not sent text messages to are shown. Toggle "Show All Pages" to see pages you have already texted or that are scheduled to be texted.</p>
    </div>
    <div class="card mt-4">
        <div class="card-body page-templates">
            <!-- <div class="card-actions">
                <div class="item">
                    <i class="far fa-list-ol"></i>
                    Grid
                </div>
                <div class="item active">
                    <i class="far fa-border-all"></i>
                    List
                </div>
            </div> -->
            <button [disabled]="!selectedPages || selectedPages.length === 0" (click)="sendNewText(sentTextModal, selectedPages)" class="clear margin-bottom-12 button button-light">
                Bulk Send Text
            </button>
            <button *ngIf="selectedPages && selectedPages.length > 0" (click)="bulkDeletePages(selectedPages, $event)" class="margin-left-12 clear margin-bottom-12 button button-red">
                Delete Pages
            </button>
            <p class="schdule-info">
                {{activeSchedules}} schedule<span *ngIf="activeSchedules !== 1">s</span><!--
                --><span *ngIf="activeSchedules === 1"> is </span><!--
                --><span *ngIf="activeSchedules !== 1"> are </span><!--
                -->pending, {{scheduledPages}} text<span *ngIf="scheduledPages !== 1">s</span>
                <span *ngIf="scheduledPages === 1"> is </span><!--
                --><span *ngIf="scheduledPages !== 1"> are </span><!--
                -->scheduled.
            </p>
            <div class="table-actions">
                <p class="table-row-indicator"><strong>Showing {{pagination.first}} to {{pagination.last}} of {{totalRecords}} pages</strong></p>
                <p class="table-row-toggle">
                    <strong>Show All Pages</strong>
                    <label class="switch">
                        <input type="checkbox" [(ngModel)]="showAllPages" (change)="this.loadData(null, null, true)" [checked]="showAllPages">
                        <span class="slider round"></span>
                    </label>
                </p>
            </div>
            <p-table #dt [responsive]="true" [value]="pages" class="page-listings"
                [(selection)]="selectedPages" dataKey="_id" [lazy]="true"
                [paginator]="true" rows="25" totalRecords="{{totalRecords}}" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {{totalRecords}} entries"
                [rowsPerPageOptions]="[25,50,100,250,500,1000]" (onPage)="paginate($event)"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th>
                            Name
                        </th>
                        <!-- <th>
                            Label
                        </th> -->
                        <th>
                            Type
                        </th>
                        <th>URL</th>
                        <th>
                            Created
                        </th>
                        <th>Actions</th>
                        <th>
                            Texts Sent
                        </th>
                    </tr>
                    <tr>
                        <th>
                        </th>
                        <th>
                            <input pInputText type="text" placeholder="Search" [(ngModel)]="pageNameSearchText" (ngModelChange)="debouncedSearch(pageNameSearchText, 'data.pageName')">
                        </th>
                        <th>
                            <input pInputText type="text" placeholder="Search" [(ngModel)]="labelSearchText" (ngModelChange)="debouncedSearch(labelSearchText, 'data.label')">
                        </th>
                        <th>
                            <input pInputText type="text" placeholder="Search" [(ngModel)]="pageTypeSearchText" (ngModelChange)="debouncedSearch(pageTypeSearchText, 'data.type')">
                        </th>
                        <th></th>
                        <th>
                        </th>
                        <th></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-page let-rowData>
                    <tr>
                        <td class="checkbox">
                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                        </td>
                        <td>
                            <i placement="top" ngbTooltip="Upcoming Text! {{page.scheduleTime | date:'MMM d, y, h:mm a'}}" *ngIf="page.scheduleIds && page.scheduleIds.length > 0 && !page.scheduleSent" class="far fa-alarm-clock"></i>
                            <i placement="top" ngbTooltip="Text already sent!" *ngIf="page.scheduleIds && page.scheduleIds.length > 0 && page.scheduleSent" class="far fa-alarm-clock past"></i>
                            {{page.data.pageName}}
                        </td>
                        <!-- <td>
                            {{page.data.label || 'N/A'}}
                        </td> -->
                        <td>
                            {{page.data.type}}
                        </td>
                        <td class="short-url-cell">
                            <span *ngIf="!page.shortUrl">Generating URL <span class="spinner-border spinner-border-sm mr-1"></span></span>
                            <a *ngIf="page.shortUrl" target="_blank" [href]="'https://sites.customnurturepages.com?id=' + page._id + '&track=false'">{{page.shortUrl}}</a>
                        </td>
                        <td>
                            {{page.updated | date:'MM-dd-yyyy hh:mm'}}
                        </td>
                        <td>
                            <p class="no-margin">
                                <!-- <i placement="top" ngbTooltip="Edit this page." class="fas fa-edit margin-right-12" (click)="onClickEditPage(page._id)"></i> -->
                                <!-- <i placement="top" ngbTooltip="Edit this page." class="fas disabled fa-edit margin-right-12"></i> -->
                                <!-- <i placement="top" ngbTooltip="Coming Soon!" class="fas disabled fa-envelope-open-text margin-right-12"></i> -->
                                <i placement="top" ngbTooltip="Send this page via text." class="fas fa-sms" (click)="sendNewText(sentTextModal, page)"></i>
                                <i placement="top" *ngIf="page.textCount === 0" ngbTooltip="Delete this page!" class="far fa-trash-alt" (click)="deletePage(page, $event)"></i>
                            </p>
                        </td>
                        <td class="text-center">
                            {{page.textCount}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<!-- Send Text Modal -->
<ng-template #sentTextModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="sendTextModalLabel">Send Text Message</h5>
        <div class="float-right">
            <button type="button" class="button button-white button-small" (click)="exitModal($event, modal)"><i class="far fa-times" aria-hidden="true"></i></button>
        </div>
    </div>
    <div class="send-text-modal modal-body">
        <div class="row">
            <div class="col-md-8">
                <div class="card">
                    <form [formGroup]="sendTextMessageForm" (ngSubmit)="deliverText(modal, bulkText)">
                        <div class="form-group" *ngIf="!bulkText">
                            <label for="recipientPhoneNumber">Recipients Phone Number (U.S.A. Only)</label>
                            <input type="number" formControlName="recipientPhoneNumber" class="form-control" [ngClass]="{ 'is-invalid': submitted && sendTextMessageForm.controls.recipientPhoneNumber.errors }" />
                            <div *ngIf="submitted && sendTextMessageForm.controls.recipientPhoneNumber.errors" class="invalid-feedback">
                                <div *ngIf="sendTextMessageForm.controls.recipientPhoneNumber.errors.required">Recipient Phone Number is required</div>
                            </div>
                        </div>
                        <div class="alert alert-danger mt-0" *ngIf="bulkText && pagesRemoved">
                            Some pages were removed for missing phone numbers.
                        </div>
                        <div class="alert alert-danger mt-0" *ngIf="bulkText">
                            You are sending this text message to {{bulkTextSendPages.length}} phone numbers! Please make sure this is your intention. If you use tokens that are not available for all pages you've selected the text content will be missing data!
                        </div>
                        <div class="form-group">
                            <label for="textMessageContent">Text Message Content</label>
                            <textarea 
                                rows="5"
                                formControlName="textMessageContent"
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && sendTextMessageForm.controls.textMessageContent.errors }"
                                maxlength="1600"
                            ></textarea>
                            <span class="helper-text">{{remainingCharacterCount()}} characters remaining</span>
                            <div *ngIf="submitted && sendTextMessageForm.controls.textMessageContent.errors" class="invalid-feedback">
                                <div *ngIf="sendTextMessageForm.controls.textMessageContent.errors.required">Text Message Content is required</div>
                            </div>
                        </div>
                        <div class="action-wrapper">
                            <button [disabled]="saveTextTemplateActive || sendingText" (click)="triggerSaveTextAsTemplate(textActionModal, $event)" class="pull-right button button-gray button-small">
                                <span *ngIf="sendingText" class="spinner-border spinner-border-sm mr-1"></span>
                                <span *ngIf="!sendingText"><i class="far fa-save"></i></span>
                                Save As Template
                            </button>
                            <button [disabled]="loadTextTemplateActive || sendingText" (click)="loadFromExistingTextTemplate(textActionModal, $event)" class="pull-right margin-right-12 button button-gray button-small">
                                <span *ngIf="sendingText" class="spinner-border spinner-border-sm mr-1"></span>
                                <span *ngIf="!sendingText"><i class="far fa-file-alt"></i></span>
                                Load Existing Template
                            </button>
                        </div>
                        <strong>Available Tokens:</strong>
                        <div class="token-wrap">
                            <span *ngFor="let key of objectKeys(activeTextData.data)" class="single-token">[{{key}}], </span>
                        </div>
                        <button [disabled]="sendingText" class="margin-right-12 button button-dark">
                            <span *ngIf="sendingText" class="spinner-border spinner-border-sm mr-1"></span>
                            Send Now
                        </button>
                        <button [disabled]="sendingText" class="margin-right-12 button button-light" (click)="openScheduleModal(scheduleTextModal, $event)">
                            <span *ngIf="sendingText" class="spinner-border spinner-border-sm mr-1"></span>
                            Schedule Send
                        </button>
                        <button [disabled]="sendingText" type="button" class="button button-white" (click)="modal.dismiss('Cancel')">
                            <span *ngIf="sendingText" class="spinner-border spinner-border-sm mr-1"></span>
                            Cancel
                        </button>
                        <span class="consent-alert">*By clicking send you are verifying you have permission to text the individuals uploaded.</span>
                        <div *ngIf="errorMessage" class="alert alert-danger mt-3 mb-0">{{errorMessage}}</div>
                    </form>
                </div>
            </div>
            <div class="col-md-4">
                <div class="relative">
                    <div class="iphone-bg">
                        <div class="chat">
                            <div class="mine messages">
                                <div class="message last">
                                    {{messagePreview()}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Load and Save Template Modal -->
<ng-template #textActionModal let-actionModal>
    <div class="modal-header">
        <h5 class="modal-title" id="sendTextModalLabel">{{modalActionTitle}}</h5>
        <div class="float-right">
            <button type="button" class="button button-white button-small" (click)="exitModal($event, actionModal)"><i class="far fa-times" aria-hidden="true"></i></button>
        </div>
    </div>
    <div class="send-text-modal modal-body">
        <div *ngIf="textTemplates" class="clear text-template-picker-wrap">
            <p class="empty-template"*ngIf="textTemplates && textTemplates.length === 0">
                No Templates Saved
                <img src="assets/empty-template.png" />
            </p>
            <p class="text-template-picker" *ngFor="let template of textTemplates; let i = index" (click)="selectTextTemplate($event, template, actionModal)">
                <span class="pull-left">{{template.name}}</span>
                <span class="pull-left template-message">
                    {{template.message}}
                </span>
                <span class="pull-right" (click)="deleteTextTemplate(template._id, i, $event)"><i class="fal fa-trash-alt" aria-hidden="true"></i></span>
            </p>
        </div>
        <div class="clear save-text-template-form form-group margin-bottom-24" *ngIf="saveTextTemplateActive">
            <div class="row form-group">
                <label for="pageName">Text Template Name</label>
                <input placeholder="Name your template!" type="text" [(ngModel)]="textTemplateName" [ngModelOptions]="{standalone: true}" class="form-control no-active-state" />
            </div>
            <button [disabled]="textTemplateSaveInAction || !textTemplateName" (click)="saveTextAsTemplate($event, actionModal)" class="button button-dark">
                <span *ngIf="textTemplateSaveInAction || sendingText" class="spinner-border spinner-border-sm mr-1"></span>
                Save
            </button>
        </div>
    </div>
</ng-template>

<!-- Schedule Text Modal -->
<ng-template #scheduleTextModal let-scheduleTextModal>
    <div class="modal-header">
        <h5 class="modal-title">Schedule Message</h5>
        <div class="float-right">
            <button type="button" class="button button-white button-small" (click)="exitModal($event, scheduleTextModal)"><i class="far fa-times" aria-hidden="true"></i></button>
        </div>
    </div>
    <div class="schedule-text-modal modal-body">
        <p>Select the date and time to send the message.</p>
        <div class="row">
            <div class="col-sm-6">
                <form class="single-date-selection form-inline calendar-padding">
                    <div class="form-group">
                      <div class="input-group">
                        <input class="form-control"
                            placeholder="yyyy-mm-dd"
                            name="dp"
                            [dayTemplate]="t"
                            [(ngModel)]="sendDate"
                            ngbDatepicker
                            #d="ngbDatepicker">
                        <ng-template #t let-date let-focused="focused">
                            <span class="custom-day"
                                    [class.focused]="focused"
                                    [class.range]="isToday(date)"
                                    [class.faded]="isHovered(date) || isInside(date)"
                                    (mouseenter)="hoveredDate = date"
                                    (mouseleave)="hoveredDate = null">
                                {{ date.day }}
                            </span>
                        </ng-template>
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"><i class="fal fa-calendar-alt"></i></button>
                        </div>
                      </div>
                    </div>
                </form>
            </div>
            <div class="col-sm-6">
                <ngb-timepicker [(ngModel)]="sendTime" [meridian]="true"></ngb-timepicker>
            </div>
        </div>
        <div class="alert alert-success mt-0" *ngIf="sendDate">
            <span>
                Your text<!--
                --><span *ngIf="true">s</span> 
                will send on {{sendDate.month}}/{{sendDate.day}}/{{sendDate.year}} 
                <span *ngIf="sendTime && sendTime.hour%12 === 0">at 12:{{("0" + sendTime.minute).slice(-2)}}</span>
                <span *ngIf="sendTime && sendTime.hour%12 !== 0">at {{sendTime.hour%12}}:{{("0" + sendTime.minute).slice(-2)}}</span>
                <span *ngIf="sendTime && (sendTime.hour === 0 || (sendTime.hour && sendTime.hour <= 11))"> AM</span>
                <span *ngIf="sendTime && sendTime.hour && sendTime.hour > 11"> PM</span>
            </span>
        </div>
        <button [disabled]="!sendTime || !sendDate || schedSaveInProgress" (click)="saveSchedule(scheduleTextModal)" class="button button-dark">
            <span *ngIf="schedSaveInProgress" class="spinner-border spinner-border-sm mr-1"></span>
            Save Schedule
        </button>
    </div>
</ng-template>